import React from 'react';
import PropTypes from 'prop-types';
import Title from '../Title';
import { Tooltip, svgSprite } from '../../../../hybrid/wrappers';
import css from './FormFieldTitle.module.scss';
import classNames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';

const FromInputTitle = ({
    id,
    errors,
    title,
    compStyle,
    hint,
    variationStyle,
    focused,
    isFilled,
    required,
    disabled = false,
    type
}) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    return (
        <div
            style={{
                ...stylers.title,
                ...(errors && errors.length ? stylers?.titleError : { ...(isFilled || focused ? stylers.titleFocus : {}) })
            }}
            className={classNames(
                css[`${variationStyle}--formTitle`],
                classes.title,
                errors && errors.length
                    ? [css.formTitleError, classes.titleError]
                    : isFilled || focused
                    ? [css.formTitleFocus, classes.titleFocus]
                    : '',
                { [css.titleTransformNotValue]: !isFilled && !focused && type !== 'phone-widget' },
                { [css.formTitleDisabled]: disabled }
            )}
        >
            <Title
                Comp={id ? 'label' : 'div'}
                body={title.body}
                links={title.links}
                data={{
                    htmlFor: id,
                    className: classes.titleLabel,
                    style: stylers.titleLabel
                }}
            />
            {!!required && (
                <p
                    style={{
                        ...stylers.requiredMark,
                        ...(!errors && focused ? stylers.requiredMarkFocus : {})
                    }}
                    className={classNames(
                        css.formControlRequiredMark,
                        classes.requiredMark,
                        !errors && focused ? [css.formControlRequiredMarkFocus, classes.requiredMarkFocus] : {}
                    )}
                >
                    *
                </p>
            )}
            {!!hint && (
                <Tooltip
                    text={hint}
                    compStyle={{ inner: css.formInfoTooltip }}
                    className={title.hintClassName || ''}
                    place={title.hintPlace || ''}
                >
                    <div
                        style={{
                            minHeight: '1rem',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        {svgSprite('question-circle-fill', {
                            className: classNames(css.formInfoTooltipSvg, classes.hintIcon),
                            style: stylers.hintIcon
                        })}
                    </div>
                </Tooltip>
            )}
        </div>
    );
};
FromInputTitle.propTypes = {
    id: PropTypes.string,
    styles: PropTypes.object,
    errors: PropTypes.array,
    title: PropTypes.object,
    compStyle: PropTypes.object,
    hint: PropTypes.node,
    variationStyle: PropTypes.string,
    focused: PropTypes.bool,
    isFilled: PropTypes.bool,
    required: PropTypes.bool
};
export default FromInputTitle;
